<template>
    <div class="goodsGroup bgc box-shadow">
        <div class="tips_box">
            商品分组功能可帮助您更高效地分类管理商品，让用户更加便捷找到所需商品。
        </div>
        <div class="btn_box">
            <div class="commodity_group_btn_box">
                <el-button @click="addNewGoodsGroup()" type="primary">新建商品分组</el-button>
            </div>
            <div class="search_btn_box">
                <el-input placeholder="输入分组名称" v-model="groupName" clearable></el-input>
                <el-button type="primary" @click="handleQuery" plain>搜索</el-button>
            </div>
        </div>
        <div class="table_box">
            <el-table :data="goodsGroupData" style="width: 100%">
                <el-table-column prop="name" label="分组名称"></el-table-column>
                <el-table-column prop="number" label="商品数" align='center'></el-table-column>
                <el-table-column prop="number" label="资鲸会员类型" align='center'>
                    <template slot-scope="scope">
                        {{ scope.row.zjmemtype === 0 ? '不支持' : (scope.row.zjmemtype === 1 ? 'PLUS卡' : '年卡') }}
                    </template>
                </el-table-column>
                <el-table-column prop="datetime" label="创建时间" align='center'></el-table-column>
                <el-table-column label="操作" align='right'>
                    <template slot-scope="scope">
                        <div class="operation_box">
                            <span @click="managementClick(scope.row.innerid, scope.row.name, scope.row.datetime)">内容管理</span>
                            <span>丨</span>
                            <span @click="editorClick(scope.row.innerid, scope.row.name, scope.row.zjmemtype)">编辑</span>
                            <!-- <span>丨</span>
                            <span @click="shareClick(scope.row.innerid)">分享</span> -->
                            <span>丨</span>
                            <span @click="delClick(scope.row.innerid)">删除</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <page :total="total" ref="page" @getList="searchClick"></page>
        </div>

        <el-dialog title="新建商品分组" :visible.sync="goodsGroupTips">
            <div class="add_goods_group_box">
                <span>分组名称</span>
                <el-input v-model="goodsGroupNewName" placeholder="请输入名称" clearable maxlength=10></el-input>
            </div>
            <div class="add_goods_group_box" v-if="user.iszjhost">
                <span>资鲸会员类型</span>
                <el-select v-model="zjmemtype">
                    <el-option label="不支持" :value="0"></el-option>
                    <!-- <el-option label="PLUS卡" :value="1"></el-option> -->
                    <el-option label="年卡" :value="2"></el-option>
                </el-select>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="goodsGroupTips = false">取 消</el-button>
                <el-button type="primary" @click="sureAdd()">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog title="编辑商品分组" :visible.sync="editGoodsGroupTips">
            <div class="add_goods_group_box">
                <span>分组名称</span>
                <el-input v-model="goodsGroupNewName" placeholder="请输入名称" clearable maxlength=10></el-input>
            </div>
            <div class="add_goods_group_box" v-if="user.iszjhost">
                <span>资鲸会员类型</span>
                <el-select v-model="zjmemtype">
                    <el-option label="不支持" :value="0"></el-option>
                    <!-- <el-option label="PLUS卡" :value="1"></el-option> -->
                    <el-option label="年卡" :value="2"></el-option>
                </el-select>
                <!-- <el-radio-group v-model="zjmemtype">
                    <el-radio :label="1">支持</el-radio>
                    <el-radio :label="0">不支持</el-radio>
                </el-radio-group> -->
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="editGoodsGroupTips = false">取 消</el-button>
                <el-button type="primary" @click="sureEdit()">确 定</el-button>
            </div>
        </el-dialog>

        <div class="right_help_box bgc padding-20" :class="showHelp ? 'show_helps_box' : 'hide_icon_box'" ref="helps">
            <div class="show_helps" :class="showHelp ? 'show_icon' : 'hide_icon'" @click="isShow()"></div>
            <div class="title_box">
                <span>基本信息</span>
                <span>进入></span>
            </div>
            <p>内容管理可添加哪些商品？</p>
            <p>可以添加图文、音频、视频、直播、专栏、大专栏、会员、分销商品。</p>
            <div class="issue_box">
                <ul>
                    <li><a href="#">商品分组使用教程</a></li>
                    <li><a href="#">能否批量添加商品？</a></li>
                    <li><a href="#">能否批量添加商品？</a></li>
                    <li><a href="#">添加完商品是否能自定义排序？</a></li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import {findAllGoodsGroup, addGoodsGroup, updateGoodsGroup, delGoodsGroup} from 'api/materialMgtApi'
import {mapGetters, mapActions} from 'vuex'
import Page from 'base/page/page'
export default {
    name: 'goodsGroup',
    data() {
        return {
            groupName: '',
            goodsGroupTips: false,
            editGoodsGroupTips: false,
            goodsGroupNewName: '',
            editGoodsGroupId: '',
            zjmemtype: 0, // 是否支持资鲸大会员 0不支持 2年卡
            total: 0,
            goodsGroupData: [],
            showHelp: false // 右侧快捷帮助菜单
        }
    },
    mounted() {
        this.getAllGoodsGroupList()
    },
    methods: {
        handleQuery() {
            this.$refs.page.handleSizeChange(1)
        },
        // 新建商品分组按钮
        addNewGoodsGroup() {
            this.goodsGroupNewName = ''
            this.goodsGroupTips = true
        },
        // 确定添加分组
        sureAdd() {
            // if (this.goodsGroupNewName === '') {
            //     this.$message.error(`商品分组名称不能为空！`)
            // }
            this.setLoading(true)
            var params = {
                name: this.goodsGroupNewName,
                zjmemtype: this.zjmemtype
            }
            addGoodsGroup({
                data: Object.assign({}, params, this.page),
                success: data => {
                    this.setLoading(false)
                    this.goodsGroupTips = false
                    this.$message({type: 'success', message: '添加成功！'})
                    this.getAllGoodsGroupList()
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                    this.goodsGroupTips = false
                }
            })
        },
        // 搜索
        searchClick() {
            this.setLoading(true)
            var params = {
                name: this.groupName
            }
            findAllGoodsGroup({
                data: Object.assign({}, params, this.page),
                success: data => {
                    this.setLoading(false)
                    this.goodsGroupData = data.data.content
                    this.total = data.data.pageinfo.rowCount
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        // 内容管理
        managementClick(value, name, datetime) {
            this.$router.push({name: 'GoodsGroupContent', query: {innerid: value, name, datetime}})
        },
        // 编辑弹窗
        editorClick(id, name, zjmemtype) {
            this.editGoodsGroupId = id
            this.goodsGroupNewName = name
            this.zjmemtype = zjmemtype
            this.editGoodsGroupTips = true
        },
        // 编辑确定按钮
        sureEdit() {
            this.setLoading(true)
            var params = {
                name: this.goodsGroupNewName,
                innerid: this.editGoodsGroupId,
                zjmemtype: this.zjmemtype
            }
            updateGoodsGroup({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.editGoodsGroupTips = false
                    this.getAllGoodsGroupList()
                    this.$message({type: 'success', message: '修改成功！'})
                },
                error: data => {
                    this.setLoading(false)
                    this.editGoodsGroupTips = false
                    console.log('error：', data)
                }
            })
        },
        // 分享
        shareClick(value) {
            this.$message.success(`分享按钮!`)
        },
        // 删除
        delClick(id) {
            this.$confirm('删除后将不可恢复，确认删除吗？', '删除分组', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                var params = {
                    innerid: id
                }
                this.setLoading(true)
                delGoodsGroup({
                    data: Object.assign({}, params),
                    success: data => {
                        this.setLoading(false)
                        this.getAllGoodsGroupList()
                        this.$message.success(`删除成功!`)
                    },
                    error: data => {
                        this.setLoading(false)
                        console.log('error：', data)
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                })
            })
        },
        // 查询所有商品分组列表
        getAllGoodsGroupList() {
            this.setLoading(true)
            findAllGoodsGroup({
                data: Object.assign({}, this.page),
                success: data => {
                    this.goodsGroupData = data.data.content
                    this.total = data.data.pageinfo.rowCount
                    this.setLoading(false)
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        // 右侧快捷帮助菜单 显示/隐藏
        isShow() {
            this.showHelp = !this.showHelp
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'page',
            'user'
        ])
    },
    components: {
        Page
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .goodsGroup {
        padding: 20px 20px 100px 20px;
        position: relative;
        .tips_box{
            background:rgba(245,247,250,1);
            height: 50px;
            line-height: 50px;
            color: #606266;
            padding: 0 20px;
        }
        .btn_box{
            margin: 20px 0;
            display: flex;
            justify-content: space-between;
            .commodity_group_btn_box{
                .el-button, .el-button--mini {
                    height: 36px;
                    width: 110px;
                }
            }
            .search_btn_box{
                display: flex;
                .el-input__inner {
                    height: 36px;
                    width: 240px;
                }
                .el-input__icon {
                    line-height: 36px;
                }
                .el-button, .el-button--mini {
                    height: 36px;
                    width: 96px;
                    margin-left: 20px;
                }
            }
        }
        .add_goods_group_box{
            display: flex;
            align-items: center;
            &:not(:last-of-type) {
                margin-bottom: 20px;
            }
            &>span{
                white-space: nowrap;
                margin-right: 20px;
                display: block;
                width: 86px;
            }
            .el-input {
                width: 400px;
            }
            .el-radio-group {
                position: relative;
                top: 2px;
            }
        }
        .table_box{
            .el-table th>.cell {
                color: #303133;
                // font-size: 16px;
                font-weight: bold;
            }
            .operation_box{
                white-space: nowrap;
                display: flex;
                align-items: center;
                justify-content: flex-end;
                span{
                    color: #409EFF;
                }
                span:nth-of-type(2n+1):hover{
                    cursor: pointer;
                    color: rgb(41, 138, 235);
                }
                span:nth-of-type(2n){
                    margin: 0 5px;
                }
            }
        }
        .right_help_box{
            position: fixed;
            top: 70px;
            right: -225px;
            height: 91vh;
            width: 225px;
            z-index: 10;
            box-sizing: border-box;
            border-top: 2px solid #409EFF;
            box-shadow: 2px 0px 6px 0px rgba(0,21,41,0.14);
            .show_helps{
                width: 12px;
                height: 50px;
                background-size:12px 50px !important;
                position: absolute;
                top: 30%;
                left: -12px;
                cursor: pointer;
                border-radius: 6px 0 0 6px;
            }
            .show_helps:hover{
                background-color: #ccc;
            }
            .show_icon{
                background-image: url('../../../common/images/other/show.png');
            }
            .hide_icon{
                background-image: url('../../../common/images/other/hide.png');
            }
            .title_box{
                display: flex;
                justify-content: space-between;
                border-left: 2px solid #409EFF;
                padding-left: 8px;
                span{
                    line-height: 16px;
                    font-weight: bold;
                }
                span:nth-of-type(2){
                    color: #409EFF;
                    font-size: 12px;
                    font-weight: normal;
                    cursor: pointer;
                }
                span:nth-of-type(2):hover{
                    color: rgb(29, 134, 238);
                }
            }
            &>p:nth-of-type(1){
                color:rgba(48,49,51,1);
                margin: 20px 0;
                font-weight: bold;
                // font-size: 15px;
                line-height:20px;
                font-family:PingFangSC-Regular;
            }
            &>p:nth-of-type(2){
                color:rgba(144,147,153,1);
                font-family:PingFangSC-Regular;
                line-height:18px;
                font-size: 12px;
                margin-bottom: 20px;
            }
            .issue_box{
                background-color: #F5F7FA;
                padding: 15px 12px;
                ul{
                    padding-left: 10px;
                    li{
                        list-style: disc;
                        margin-bottom: 15px;
                        a{
                            font-size:13px;
                            height:18px;
                            color:rgba(64,158,255,1);
                            font-family:PingFangSC-Regular;
                            line-height:18px;
                        }
                    }
                    li:nth-last-of-type(1){
                        margin-bottom: 0;
                    }
                }
            }
        }
        .show_helps_box{
            right: 0;
            transition: 1s all;
        }
        .hide_icon_box{
            right: -225px;
            transition: 1s all;
        }
    }
</style>
<style>
    .el-dialog__wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: left;
    }
    .el-dialog {
        margin: 0!important;
    }
</style>
